import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from "@angular/material/core";
import { MatCalendar } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { Subject, takeUntil } from "rxjs";

const YEARS_PER_PAGE = 24;  // same as Angular Material

@Component({
    selector: "app-custom-datepicker-header",
    styles: [
        `
         .du-cal-custom-header {
           display: flex;
           align-items: center;
           justify-content: center;
           padding: 0.5em;
         }
     
         .du-cal-custom-header-label {
           flex: 1;
           text-align: center;
           font-weight: 500;
           font-size: 14px;
           line-height: 24px;
         }
       `,
    ],
    template: `
    <div class="du-cal-custom-header">
      <button mat-icon-button (click)="previousClicked()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>

      <!-- <span class="custom-header-label"
            (click)="_calendar.currentView = _calendar.currentView === 'multi-year' ? 'year' : 'multi-year'"> -->
      <span class="du-cal-custom-header-label">
        {{ periodLabel }}
      </span>

      <button mat-icon-button (click)="nextClicked()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatIconModule]
})
export class AppCustomDatepickerHeaderComponent<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
    public _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef
  ) {
    _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => cdr.markForCheck());
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  /** Label exactly like Angular Material */
  get periodLabel(): string {
    if (this._calendar.currentView === "multi-year") {
      const activeYear = this._dateAdapter.getYear(this._calendar.activeDate);
      const firstYear = Math.floor(activeYear / YEARS_PER_PAGE) * YEARS_PER_PAGE;
      const lastYear = firstYear + YEARS_PER_PAGE - 1;

      return `${firstYear} – ${lastYear}`;
    }

    if (this._calendar.currentView === "year") {
      return this._dateAdapter.getYear(this._calendar.activeDate).toString();
    }

    // month view
    return this._dateAdapter.format(this._calendar.activeDate, this._dateFormats.display.monthYearA11yLabel);
  }

  /** Navigate same as Angular Material */
  previousClicked() {
    if (this._calendar.currentView === "multi-year") {
      this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, -YEARS_PER_PAGE);
    } else if (this._calendar.currentView === "year") {
      this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
    } else {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
    }
  }

  nextClicked() {
    if (this._calendar.currentView === "multi-year") {
      this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, YEARS_PER_PAGE);
    } else if (this._calendar.currentView === "year") {
      this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
    } else {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1);
    }
  }
}
